import { gql } from '@apollo/client'
import { EHR_APPOINTMENT_FIELDS } from '@src/graphql/fragments/ehrAppointment'

export const EHR_APPOINTMENTS = gql`
  ${EHR_APPOINTMENT_FIELDS}
  query ehrAppointments(
    $sorts: [EhrAppointmentSort!]
    $dynamicFilters: [EhrAppointmentDynamicFilterItem!]
    $filterKind: FilterAppointmentsKind
    $category: EhrAppointmentCategory
  ) {
    ehrAppointments(
      sorts: $sorts
      dynamicFilters: $dynamicFilters
      filterKind: $filterKind
      category: $category
    ) {
      appointments {
        ...EhrAppointmentFields
      }
    }
  }
`
